import React, { useMemo } from "react";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useGetHtmlApiQuery } from "../../redux/services/apiHome";
import Loader from "../../components/Loader";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { getLastUpdatedOn } from "../../Utils/apiFunctions";
import PageLastUpdated from "../../components/shared/PageLastUpdated";

const ImportantLinks = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const { data: lastUpdatedOnData = [], isLoading: lastUpdatedIsLoading } =
    useGetProtectedApiDataQuery({
      url: "basic_page",
      lang: languageType,
    });
  const lastUpdatedOn = useMemo(
    () => getLastUpdatedOn(lastUpdatedOnData, 28753),
    [lastUpdatedOnData],
  );

  const { data: screenReaderData = {}, isLoading: screenReaderAccessLoading } =
    useGetHtmlApiQuery({ url: 28753, lang: languageType });

  if (screenReaderAccessLoading) {
    return <Loader />;
  }

  const pageBody = screenReaderData?.body?.[0]?.processed || "";

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("Important Links", "महत्वपूर्ण लिंक")}
        titleLink="/screen-reader"
        levelTwo={false}
        levelThree={false}
        isActive={getText("Important Links", "महत्वपूर्ण लिंक")}
      />
      <div className="inner-container">
        <div className="container">
          <div className="container about_inntxt">
            <div className="row">
              <div className="container">
                <div className="important-links">
                  <div dangerouslySetInnerHTML={{ __html: pageBody }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-4">
        <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
      </div>
    </>
  );
};

export default ImportantLinks;
